/** Shared identity contract; importing it must not load the activity dispatcher. */
export const BURNABLE_LIGHT_IDS: ReadonlySet<string> = new Set([
    '4A77B6AA-17C7-DDA6-C5ED-28DD38513C48', '105BDD18-BC99-9F5D-F92F-3D5DAC8C235A', '55D75BB2-ABF3-BB28-34FC-72A1B4FFEE02',
    'D9C8AD45-023D-0F08-18E1-12D6C21BF0E0', '634BE906-3321-4CA1-9C01-E7D07CDFF10F', 'B46E6FD6-32A6-FD02-40CA-D66C9A194FFF',
    '4AAB51D1-370B-4EC3-9009-8DB369C84CDF', 'EFC3CB70-B502-459D-A60F-6A44195C1CA5', 'DE99838F-DCC7-DF81-D4B2-48ADA2A97262',
    'CD6CA186-69D2-9DE3-0F90-72096B708F5A', '3097FACE-7132-6AA0-807F-359D6F7C3BC0', 'D76632FE-D53F-C897-D706-D9B5471A66F5',
    'FBB150CD-7783-A81B-60A2-A757FFC44C4F', 'BD659DC9-EE94-EE5A-A82D-2DA42D803FEA',
]);
